var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"segment-fat-data"},[_vm._m(0),_vm._l((_vm.newDataArray),function(item,index){return _c('div',{key:index},[(_vm.isSpecial(item))?_c('bodydata-item',{attrs:{"chart":item,"index":index,"styleChildren":_vm.styleContent}}):_vm._e()],1)})],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"thermal-title"},[_c('span')])
}]

export { render, staticRenderFns }